/* The collection page's controls (sections/st-collection.liquid). They ship hidden and are shown
   here, so without this file the page is the cards with their "Down to" line.
   - Platform chips (on a collection that mixes platforms; snippets/st-platform-chips.liquid and
     assets/st-filter.js, which loads first) and format chips: each shows the cards of one platform or
     one product type, and the two combine (every product is on the page, so this is a filter of the
     page, not a new request). Each chip's count is what it would show with the other filter as it
     is. The count under them is a polite live region; when nothing matches, a line says so with a
     button that shows every product again.
   - Unit price at a pack size: rewrites each card's per-unit line to what one unit costs at that size,
     from the prices the card carries (data-st-packs, each already formatted by Shopify's money filter).
     A product not sold at that size says where its packs start or stop instead. The largest size is
     chosen on load. */
(() => {
  const fill = (tpl, map) => Object.entries(map).reduce((s, [k, v]) => s.split(k).join(v), tpl || '');

  // A template such as "__P__ a __U__ at __S__" as nodes, the price in <b>, everything else as text.
  const line = (tpl, map) => {
    const frag = document.createDocumentFragment();
    const parts = tpl.split('__P__');
    parts.forEach((part, n) => {
      if (n > 0) {
        const b = document.createElement('b');
        b.textContent = map.__P__;
        frag.append(b);
      }
      frag.append(document.createTextNode(fill(part, map)));
    });
    return frag;
  };

  function init(section) {
    if (section.dataset.stReady) return;
    section.dataset.stReady = 'true';
    const items = [...section.querySelectorAll('.st-coll__grid > li')];
    const status = section.querySelector('[data-st-status]');
    const formats = section.querySelector('[data-st-formats]');
    const plats = section.querySelector('st-platform-filter');
    const none = section.querySelector('[data-st-none]');
    const unit = section.querySelector('[data-st-unit]');
    const total = items.length;
    const facts = items.map((li) => {
      const tile = li.querySelector('.st-ptile');
      return { type: tile?.dataset.stType || '', platform: tile?.dataset.stPlatform || '' };
    });
    const Filter = window.StFilter;
    const state = { type: '', platform: plats && typeof plats.value === 'string' ? plats.value : '' };

    const refilter = (announce) => {
      let shown = 0;
      items.forEach((li, n) => {
        const on = Filter ? Filter.match(facts[n], state) : !state.type || facts[n].type === state.type;
        li.hidden = !on;
        if (on) shown += 1;
      });
      if (Filter) {
        if (formats) {
          formats.querySelectorAll('[data-st-type]').forEach((chip) => {
            const n = chip.querySelector('.st-chip__n');
            if (n) n.textContent = String(Filter.count(facts, state, 'type', chip.dataset.stType));
          });
        }
        if (plats && typeof plats.setCounts === 'function') {
          const counts = { '': Filter.count(facts, state, 'platform', '') };
          plats.querySelectorAll('[data-st-plat]').forEach((chip) => {
            counts[chip.dataset.stPlat] = Filter.count(facts, state, 'platform', chip.dataset.stPlat);
          });
          plats.setCounts(counts);
        }
      }
      if (none) none.hidden = shown > 0;
      if (status && (announce || shown !== total)) status.textContent = fill(section.dataset.stCountTpl, { __N__: shown, __T__: total });
    };

    if (formats) {
      formats.hidden = false;
      formats.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-st-type]');
        if (!chip) return;
        state.type = chip.dataset.stType;
        formats.querySelectorAll('[data-st-type]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
        refilter(true);
      });
    }

    if (plats) {
      plats.addEventListener('change', () => {
        state.platform = plats.value || '';
        refilter(true);
      });
    }

    // Nothing matches both filters: back to every product, and focus to the All chip, since the
    // button that was pressed hides with the line.
    none?.querySelector('[data-st-reset]')?.addEventListener('click', () => {
      state.type = '';
      formats?.querySelectorAll('[data-st-type]').forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.stType === '')));
      if (plats?.value && typeof plats.select === 'function') plats.select('');
      else refilter(true);
      const back = plats?.querySelector('[data-st-plat=""]') || formats?.querySelector('[data-st-type=""]');
      back?.focus();
    });

    refilter(false);

    if (unit) {
      unit.hidden = false;
      const hint = document.createElement('p');
      hint.className = 'st-coll__hint';
      unit.after(hint);
      const apply = (size) => {
        unit.querySelectorAll('[data-st-size]').forEach((b) => b.setAttribute('aria-pressed', String(Number(b.dataset.stSize) === size)));
        hint.textContent = size === 1 ? section.dataset.stHintOne : fill(section.dataset.stHint, { __S__: size });
        section.querySelectorAll('[data-st-packs]').forEach((card) => {
          let packs;
          try {
            packs = JSON.parse(card.dataset.stPacks).sort((a, b) => a.q - b.q);
          } catch (e) {
            return;
          }
          if (!packs.length) return;
          const noun = card.dataset.stNoun || '';
          const lo = packs[0];
          const hi = packs[packs.length - 1];
          const at = packs.find((p) => p.q === size);
          let el = card.querySelector('.st-card-unit');
          if (!el) {
            el = document.createElement('p');
            el.className = 'st-card-unit';
            card.querySelector('.st-ptile__price')?.after(el);
          }
          const span = document.createElement('span');
          if (at) {
            // The noun comes from a single unit's option ("1 Card"); a product whose smallest pack is
            // more than one ("3 Keychains") says "each" instead.
            const tpl = noun ? section.dataset.stLine : section.dataset.stLineEach;
            span.append(line(tpl, { __P__: at.m, __U__: noun, __S__: size }));
            const save = Math.round((1 - at.c / lo.c) * 100);
            if (save >= 5) {
              const s = document.createElement('span');
              s.className = 'st-coll__save';
              s.textContent = ` · ${fill(section.dataset.stSave, { __X__: save })}`;
              span.append(s);
            }
          } else if (size < lo.q) {
            span.append(line(section.dataset.stFrom, { __P__: lo.m, __S__: lo.q }));
          } else {
            span.append(line(section.dataset.stUpto, { __P__: hi.m, __S__: hi.q }));
          }
          el.replaceChildren(span);
        });
      };
      unit.addEventListener('click', (event) => {
        const b = event.target.closest('[data-st-size]');
        if (b) apply(Number(b.dataset.stSize));
      });
      const start = unit.querySelector('[aria-pressed="true"]') || unit.querySelector('[data-st-size]:last-child');
      if (start) apply(Number(start.dataset.stSize));
    }
  }

  const run = () => document.querySelectorAll('.st-coll').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
